import baseEditForm from 'formiojs/components/fieldset/Fieldset.form';
import BaseEditConditionalComponents from '../../../configuration-components/base-widget-configuration/base.edit.conditional.components';
import LenderOnly from '../../../configuration-components/base-widget-configuration/display/lender-only-field-checkbox';
import HideInPdf from '../../../configuration-components/base-widget-configuration/display/hide-in-pdf-checkbox';

export default function (...extend: any[]) {
	return baseEditForm(
		[
			{
				key: 'display',
				components: [HideInPdf, LenderOnly]
			},
			{
				key: 'api',
				ignore: true
			},
			{
				key: 'conditional',
				components: BaseEditConditionalComponents
			},
			{
				key: 'logic',
				ignore: true
			},
			{
				key: 'layout',
				ignore: true
			}
		],
		...extend
	);
}
